import { usePaymentSource } from '@zapier/payment';
import { useCurrentAccountId } from '@zapier/design-system-revenue/src/hooks';

export const useData = () => {
  const { accountId } = useCurrentAccountId();
  const {
    isLoading: isPaymentSourceLoading,
    primarySource,
  } = usePaymentSource({ accountId });

  return {
    isPaymentMethodProvided: Boolean(primarySource),
    isPaymentSourceLoading,
  };
};
